export default {spreads:{BaseStorableSummary:{},HasCreator:{}},restOnlyFields:{sourceId:{fieldResolver:'Storable:sourceId'}}}